import { connect } from 'react-redux'
import EditContributionDialog from './edit-contribution-dialog'

import {
  editContribution,
  editContributionReply,
  closeEditContributionDialog
} from '../../../../../../../stores/discussion/discussion.actions'
import { editContributionDialogOpen } from '../../../../../../../stores/discussion/discussion.selectors'

const mapStateToProps = state => {
  const dialog = editContributionDialogOpen(state)
  return {
    isOpen: dialog.opened,
    id: dialog.id,
    contributionId: dialog.contributionId,
    body: dialog.body,
    pending: false,
    parentId: dialog.parentId
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onClose: () => dispatch(closeEditContributionDialog()),
  onUpdate: editedBody => {
    return stateProps.parentId
      ? dispatch(
          editContributionReply(
            stateProps.id,
            stateProps.contributionId,
            editedBody,
            stateProps.parentId
          )
        )
      : dispatch(
          editContribution(stateProps.id, stateProps.contributionId, editedBody)
        )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(EditContributionDialog)
